@let segments = store.sortedSegmentsSg();
@let currentSegmentId = store.currentSegmentIdSg();

<div
  class="atn-mosaic-segment-tabs"
  cdkDropList
  (cdkDropListDropped)="segmentDropHandler($event)"
>
  @for (segment of segments; track segment.id) {
    <div
      cdkDrag
      class="atn-mosaic-segment-tabs__tab"
      [class.atn-mosaic-segment-tabs__tab--selected]="
        segment.id === currentSegmentId
      "
      (click)="segmentClickHandler(segment)"
    >
      <div class="atn-mosaic-segment-tabs__left-content">
        <i class="atn-icon atn-drag atn-mosaic-segment-tabs__drag-icon"></i>

        <div class="atn-mosaic-segment-tabs__tab-name">
          {{ segment.name }}
        </div>
      </div>
      <div class="atn-mosaic-segment-tabs__tab-actions">
        <i
          (click)="editSegmentClickHandler(segment.id, $event)"
          [class.atn-blue]="segment.id !== currentSegmentId"
          [class.atn-light]="segment.id === currentSegmentId"
          class="atn-icon atn-edit atn-mosaic-segment-tabs__tab-action-icon"
        ></i>
      </div>
    </div>
  }
</div>
